<template>
	<PayUnlockShell v-bind="shellProps" @select="$emit('select')">
		<template #left>
			<PayIcon icon="community" color="#fff" :bg="btnColor" :h5="h5" />
		</template>
		<template #info>
			<p class="g-block-pay-unlock__desc">{{ data.title || '加入社群' }}</p>
			<p class="g-block-pay-unlock__count">{{ data.subtitle || '优质资源 · 每日更新' }}</p>
			<div class="g-block-pay-unlock__prices">
				<span class="g-block-pay-unlock__price" :style="priceColor">¥ {{ displayPrice }}</span>
			</div>
		</template>
		<template #action>
			<PayUnlockButton
				:text="data.buttonText || '立即加入'"
				:style="buttonStyle"
				@click="onButtonClick"
			/>
		</template>
	</PayUnlockShell>
</template>

<script>
	import PayUnlockShell from '../shared/PayUnlockShell.vue';
	import PayUnlockButton from '../shared/PayUnlockButton.vue';
	import PayIcon from '../shared/PayIcon.vue';
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice, getButtonColor } from '../shared/utils.js';
	import { DEFAULT_PAY_UNLOCK_COMMUNITY } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockCommunity',
		components: { PayUnlockShell, PayUnlockButton, PayIcon },
		mixins: [payUnlockMixin],
		computed: {
			defaultButtonColors() {
				return DEFAULT_PAY_UNLOCK_COMMUNITY;
			},
			btnColor() {
				return getButtonColor(this.data, DEFAULT_PAY_UNLOCK_COMMUNITY);
			},
			priceColor() {
				return { color: this.btnColor };
			},
			shellProps() {
				return {
					data: this.data,
					editable: this.editable,
					active: this.active,
					fixedBottom: this.fixedBottom,
					h5: this.h5,
				};
			},
			displayPrice() {
				return formatPayPrice(this.data.price);
			},
		},
	};
</script>
